import { createSlice } from "@reduxjs/toolkit";

const recommendationEngineSlice = createSlice({
  name: "recommendationEngine",
  initialState: {
    recommendationActions: [],
  },
  reducers: {
    setActionList: (state, action) => {
      return {
        ...state,
        recommendationActions: action.payload,
      };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = recommendationEngineSlice;

// Extract and export each action creator by name
export const { setActionList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
